import { Icon, IconProps } from '@chakra-ui/react'
import { FaReddit } from 'react-icons/fa'

export function RedditIcon(props: IconProps) {
  return <Icon as={FaReddit} {...props} />
}
